import { DecimalPipe } from '@angular/common';
import { Component, OnChanges, inject, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitRatingResponse} from '../../../model/unit-rating-response';
import {GuruEntity} from '../../../model/guru-entity';
import {SelectionUtils} from '../../selection-utils';
import {UnitConversionUtils} from '../../unit-conversion-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { PerformanceResultsComponent } from '../../common/performance-results/performance-results.component';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-ddbc-performance-results',
    templateUrl: './ddbc-performance-results.component.html',
    styleUrls: ['./ddbc-performance-results.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, PerformanceResultsComponent, DecimalPipe]
})
export class DdbcPerformanceResultsComponent implements OnChanges {
  private userStateService = inject(UserStateService);
  readonly ratingResponse = input.required<UnitRatingResponse>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  airflow = 0;
  standardAirflow = 0;
  highSpeedVoltage = 0;
  mediumSpeedVoltage = 0;
  lowSpeedVoltage = 0;
  isExpanded = true;
  isMetric = false;
  private sectionKey = ConfigurationSection.PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.clearOutputValues();
    const metricInput = SelectionUtils.getEntity(this.selectionEntities(), 'USMetricInput');
    this.isMetric = metricInput && 'true' === metricInput.Value;
    if (this.ratingResponse() && this.ratingResponse().HighSpeed) {
      this.airflow = this.ratingResponse().HighSpeed.Airflow;
      this.standardAirflow = this.ratingResponse().StandardAirflow ?? 0;
      this.highSpeedVoltage = this.ratingResponse().HighSpeed?.ControlVoltage ?? 0;
      this.mediumSpeedVoltage = this.ratingResponse().MediumSpeed?.ControlVoltage ?? 0;
      this.lowSpeedVoltage = this.ratingResponse().LowSpeed?.ControlVoltage ?? 0;
    }
  }

  private clearOutputValues(): void {
    this.airflow = 0;
    this.standardAirflow = 0;
    this.highSpeedVoltage = 0;
    this.mediumSpeedVoltage = 0;
    this.lowSpeedVoltage = 0;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  getAirflowMeasurementUnits(isStandard: boolean): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric, isStandard);
  }

}
